import iconTel from "../../../../assets/icon_tel.svg";
import useReactGASend from "../../../../hooks/useReactGASend";

const PhoneButton = ({ label, href }) => {
  const { makeEventTrackFn } = useReactGASend();

  const handleClick = () => {
    makeEventTrackFn({
      category: "event",
      action: `${label}(FAQ)`,
      body: {
        data_btn_nm: label,
        data_btn_url: href,
      },
    });
  };

  return (
    <a
      href={`tel:${href}`}
      className="flex items-center justify-center gap-6 p-2 font-medium leading-none bg-white border-2 min-h-12 w-60 text-neutral-900 border-neutral-600 rounded-2xl"
      onClick={handleClick}
    >
      <img src={iconTel} alt="전화걸기" />
      {label}
    </a>
  );
};

export default PhoneButton;
